import { cn } from '@v2/shared/lib/utils';
import React, { ReactNode } from 'react';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  icon?: IconLookup;
  pill?: boolean;
  padding?: 'tight' | 'snug' | 'loose';
  className?: string;
  children: ReactNode;
};

export default function Badge({ icon, pill, padding = 'tight', className, children }: Props) {
  const paddingClass = {
    tight: 'px-1',
    snug: 'px-3 py-1',
    loose: 'px-2 py-2',
  }[padding];

  return (
    <span
      className={cn(
        'inline-block text-red-600 bg-red-50 font-semibold',
        pill ? 'rounded-full' : 'rounded',
        paddingClass,
        className
      )}
    >
      {icon && <FontAwesomeIcon icon={icon} className="mr-1.5" />}
      {children}
    </span>
  );
}
